<template>
  <div class="height-50 s_font_b fz-16 s_flex_center">选择批次</div>
  <van-search
    v-model="search.keyword"
    show-action
    placeholder="请输入批次号/批次ID进行搜索"
  >
    <template #action>
      <div class="height-34 s_flex_center s_bf054 width-55 tw-text-white tw-rounded-sm" @click="onSearch">搜索</div>
    </template>
  </van-search>
  <div class="s_bf5" v-if="list.length">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="我也是有底线的~"
        @load="onLoad"
      >
        <div class="s_bf p-l-15 p-r-15" v-for="(item,index) in list" :key="index" @click="onSelect(item)">
          <div class="s_flex_bian_c height-50 s_wrap ">
            <p class="fz-14 width90">{{item.batch_name}}</p>
            <van-icon name="arrow" size="16px" color="#969799"/>
          </div>
          <van-divider :style="{ margin: '0' }" />
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
  <van-empty v-else :image="require('@/assets/image/empty.png')" description="暂无批次" />
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { Toast } from 'vant';
  import { iscode } from '@/utils/app.js';
  import { SplitArray } from "@/utils/util";
	import { getProductBatch } from '@/api/public.js';
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 10,
    keyword: "",
    to_store_id: ""
  };
  export default {
		name:"selectGoodBatch",
    props:{
      storeId: {
        type: [String, Number]
      }
    },
    setup(props, { emit }) {
      const search = ref({ ...defSearch });
      const state = reactive({
        list:[],
        loading: false, // 是否处于加载状态，加载过程中不触发 load 事件
        finished: false, // 是否已加载完成，加载完成后不再触发 load 事件
        refreshing: false, // 是否处于加载中状态
      })
      //获取列表
      const getList = async() =>{
        if (state.finished && state.loading) return
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration:0
        });
        let paramsData = {...search.value}
        paramsData.to_store_id = props.storeId || ""
				let result = await getProductBatch({ ...paramsData}).then(res => res.data).catch(error => error)
        console.log(result)
        Toast.clear();
				if (iscode(result)) {
					var listData = result.data || [];
					var list = SplitArray(listData, state.list);
					var finished = listData.length < search.value.limit;
					state.list = list;
					state.finished = finished;
          state.loading = false;
				}else{
          Toast.fail(result.msg);
				}
      }
      // 上拉加载
      const onLoad = () => {
        search.value.page =  search.value.page+1
			  getList();
      };
      //下拉刷新
      const onRefresh = () => {
        state.finished = false;
        setTimeout(()=>{
          state.list = [];
          search.value = { ...search.value, page: 1 };
          getList();
        },500)
      };
      const onSearch = (e) =>{
        onRefresh();
      }
      const onSelect = (e) =>{
        emit("select",e);
      }
      onMounted(() => {
        getList();
      })
      return {
        ...toRefs(state),
        search,
        onSearch,
        onSelect,
        onLoad,
        onRefresh
      };
    }
  };
</script>
